import '/@/design/index.less';
import 'virtual:windi-base.css';
import 'virtual:windi-components.css';
import 'virtual:windi-utilities.css';
import 'driver.js/dist/driver.min.css';
// Register icon sprite
import 'virtual:svg-icons-register';
import App from './App.vue';
import { createApp } from 'vue';
import { initAppConfigStore } from '/@/logics/initAppConfig';
import { setupErrorHandle } from '/@/logics/error-handle';
import { router, setupRouter } from '/@/router';
import { setupRouterGuard } from '/@/router/guard';
import { setupStore } from '/@/store';
import { setupGlobDirectives } from '/@/directives';
import { setupI18n } from '/@/locales/setupI18n';
import { registerGlobComp } from '/@/components/registerGlobComp';
import V3ColorPicker, { directive } from 'v3-color-picker';
import Icons from '@basicai/icons';
import { rewriteSession } from './utils/business/session';
import './global/index';

// Importing on demand in local development will increase the number of browser requests by around 20%.
// This may slow down the browser refresh speed.
// Therefore, only enable on-demand importing in production environments .
if (import.meta.env.DEV) {
  import('ant-design-vue/dist/antd.less');
}

async function bootstrap() {
  const app = createApp(App);

  app.use(Icons);
  app.use(V3ColorPicker, { name: 'colorPicker' });
  app.directive('color-picker', directive);

  // Configure store
  setupStore(app);

  // Initialize internal system configuration
  initAppConfigStore();

  // Register global components
  registerGlobComp(app);

  // Multilingual configuration
  // Asynchronous case: language files may be obtained from the server side
  await setupI18n(app);

  // Configure routing
  setupRouter(app);

  // router-guard
  setupRouterGuard(router);

  // Register global directive
  setupGlobDirectives(app);

  // Configure global error handling
  setupErrorHandle(app);

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();

  // 偶现网络抖动导致应用前置的一些资源出现问题，导致切换路由的时候出现异步加载模块失败
  // 针对这种情况重新加载目的页面
  router.onError((error, to) => {
    if (error.message.includes('Failed to fetch dynamically imported module')) {
      // console.log('in router.onError');
      window.location.href = location.origin + to.fullPath;
      window.location.reload();
    }
  });
  // 针对偶现的ERR_FAILED的情况也采取刷新(不包括如403这种由状态码的情况)
  const errReg = /(beisai\.com|basic\.ai)\/.+\.js +net::ERR_FAILED(?!\s+\d+)/;
  window.addEventListener(
    'error',
    (err) => {
      if (errReg.test(err.message)) {
        // console.log('in window.addEventListener.onError');
        window.location.reload();
      }
    },
    true /*一定要在捕获阶段截取 */,
  );

  app.mount('#app');
}

bootstrap();

rewriteSession();
